import { Button } from "@heroui/react";
import Cookies from "universal-cookie";
import { useEffect, useState } from "react";
import { burl, DOMAIN_FOR_COOKIES } from "@/config/site";
import { useUserStore, urlParams } from "./login/loginStore";
import { postData } from "@/utils/requests";
import { useTranslation } from "react-i18next";

export default function CookieConsent() {
  const { t } = useTranslation();
  const cookies = new Cookies();

  const [consent, setConsent] = useState(false);

  const [BLRef, setBLRef] = [
    useUserStore((state) => state.BLRef),
    useUserStore((action) => action.setBLRef),
  ];

  const email = useUserStore((state) => state.email);

  const genToken = () => {
    return Math.random().toString(36).substring(2);
  };

  useEffect(() => {
    if (cookies.get("consent")) {
      setConsent(true);
    }
  }, [cookies]);

  useEffect(() => {
    setBLRef(!!urlParams.get("gclid"));
  }, [urlParams]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    let currentCookieEmail = cookies.get("email");
    if (currentCookieEmail && currentCookieEmail != email) {
      cookies.set("email", email, {
        maxAge: 24 * 3600 * 3650,
        domain: DOMAIN_FOR_COOKIES

      });
    }
  }, [email]);

  const init = () => {
    if (!cookies.get("id"))
      cookies.set("id", genToken(), {
        maxAge: 24 * 3600 * 3650,
        sameSite: "none",
        secure: true, domain: DOMAIN_FOR_COOKIES
      });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("utm_campaign")) {
      cookies.set("utm_campaign", urlParams.get("utm_campaign"), {
        maxAge: 24 * 3600 * 3650,
        sameSite: "none",
        secure: true, domain: DOMAIN_FOR_COOKIES
      });
    } else {
      if (
        window.location.host != "craquestats.com.br" &&
        window.location.host != "www.craquestats.com.br" &&
        window.location.hostname != "localhost"
      )
        cookies.set("utm_campaign", "origin-" + window.location.host, {
          maxAge: 24 * 3600 * 3650,
          sameSite: "none",
          secure: true, domain: DOMAIN_FOR_COOKIES
        });
    }

    if (urlParams.has("a") && !BLRef) {
      cookies.set("afiliado", urlParams.get("a"), {
        maxAge: 24 * 3600 * 3650,
        sameSite: "none",
        secure: true
        , domain: DOMAIN_FOR_COOKIES
      });
      cookies.set("a", urlParams.get("a"), {
        maxAge: 2 * 3600,
        sameSite: "none",
        secure: true, domain: DOMAIN_FOR_COOKIES
      });
    }

    if (
      urlParams.has("a") &&
      !BLRef &&
      window.location.pathname.includes("register")
    ) {
      cookies.set("afiliado_register", urlParams.get("a"), {
        maxAge: 5 * 60,
        sameSite: "none",
        secure: true, domain: DOMAIN_FOR_COOKIES
      });
    }
    if (typeof cookies.get("first_contact") === "undefined") {
      cookies.set("first_contact", document.referrer, {
        maxAge: 24 * 3600 * 3650,
        sameSite: "none",
        secure: true, domain: DOMAIN_FOR_COOKIES
      });
    }

    if (urlParams.has("sa")) {
      cookies.set("sa", urlParams.get("sa"), {
        maxAge: 3600 * 5,
        sameSite: "none",
        secure: true, domain: DOMAIN_FOR_COOKIES
      });
    }
  };

  const confirmConsent = () => {
    var consentVersion = "1.0";

    postData(
      burl(`/api/consent`),
      {
        id: cookies.get("id"),
        email: cookies.get("email"),
        version: consentVersion,
      },
      () => {
        cookies.set("consent", consentVersion, {
          maxAge: 24 * 3600 * 3650,
          sameSite: "none",
          secure: true, domain: DOMAIN_FOR_COOKIES
        });
        setConsent(true);
        init();
      }
    );
  };

  return (
    consent || (
      <div className="pointer-events-auto flex w-full items-center justify-between gap-x-20 rounded-large border border-divider bg-background/15 px-6 py-4 shadow-small backdrop-blur">
        <p className="text-small font-normal text-default-700">
          {t("cookie_consent.cookie_consent_1")}
        </p>
        <div className="flex items-center gap-2">
          <Button
            className="px-4 font-medium"
            radius="lg"
            style={{
              border: "solid 2px transparent",
              backgroundImage: `linear-gradient(hsl(var(--heroui-background)), hsl(var(--heroui-background))), linear-gradient(83.87deg, hsl(var(--heroui-primary-800)), hsl(var(--heroui-primary-600)))`,
              backgroundOrigin: "border-box",
              backgroundClip: "padding-box, border-box",
            }}
            onClick={confirmConsent}
            id="acceptCookies"
          >
            {t("cookie_consent.cookie_consent_2")}
          </Button>
        </div>
      </div>
    )
  );
}
